import { render, staticRenderFns } from "./SummaryDelivery.vue?vue&type=template&id=59205b28&"
import script from "./SummaryDelivery.vue?vue&type=script&lang=js&"
export * from "./SummaryDelivery.vue?vue&type=script&lang=js&"
import style0 from "./SummaryDelivery.vue?vue&type=style&index=0&id=59205b28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports